import { Navigate } from 'react-router-dom';

const ServicesAdmin = () => {
  return <Navigate to="/admin/pages?page=services" replace />;
};

export default ServicesAdmin;
